import User from '@/models/user';
import { UserProps } from '@/interfaces/models/user';

export default () => {
  if (Array.isArray(window.axios.defaults.transformResponse)) {
    return window.axios.defaults.transformResponse.concat((usersProps: UserProps[]) => {
      return usersProps.map((userProps: UserProps) => new User(userProps));
    });
  }
};
